// extracted by mini-css-extract-plugin
module.exports = {"lia-solution-count":"UserSolutionCount_lia-solution-count__cyuGT"};